export const ja = {
  heroData: {
    title: "キャンセルポリシー",
    subtitle: "ご予約後に万が一キャンセルされる場合の規定をご案内します。予めご確認ください。",
    image: "https://readdy.ai/api/search-image?query=Calm%20serene%20sky%20with%20soft%20clouds%20during%20sunset%2C%20peaceful%20and%20reassuring%20atmosphere%2C%20deep%20navy%20blue%20and%20warm%20gold%20gradient%20sky%2C%20minimalist%20nature%20photography%2C%20no%20text%2C%20high%20quality&width=1920&height=600&seq=cancelhero01&orientation=landscape",
  },
  policyData: {
    label: "POLICY",
    title: "キャンセル規定",
    items: [
      { period: "搭乗日の8日前まで", fee: "無料", desc: "キャンセル料は発生しません。別日への変更も承ります。" },
      { period: "搭乗日の7日前〜2日前", fee: "料金の30%", desc: "キャンセル料が発生します。別日への変更は一度のみ承ります。" },
      { period: "搭乗日の前日", fee: "料金の50%", desc: "キャンセル料が発生します。当日の変更は承れません。" },
      { period: "搭乗当日・無断キャンセル", fee: "料金の100%", desc: "キャンセル料が発生します。" },
    ],
  },
  weatherPolicy: {
    label: "WEATHER",
    title: "天候による欠航について",
    items: [
      "安全が最優先です。運航会社の判断により、視界不良・強風・雷雨などで欠航となる場合があります",
      "欠航の判断は、原則として搭乗日の当日朝に行います",
      "欠航となった場合は、別日への振替または全額返金を選択いただけます",
      "欠航による返金は、キャンセル料は発生しません",
      "天候が不安定な場合は、事前にスタッフがご連絡する場合があります",
    ],
  },
  otherNotes: {
    label: "NOTE",
    title: "その他の注意事項",
    items: [
      "ご予約の変更（日時・人数）は、搭乗日の7日前までにご連絡ください",
      "人数の減少による料金変更は、原則として承れません",
      "ギフトチケットの有効期限は、購入日から6か月間です",
      "ギフトチケットの返金は、購入後7日以内に限り承ります",
      "特別な事情（疾病・災害等）によるキャンセルは、個別にご相談ください",
    ],
  },
};

export const en = {
  heroData: {
    title: "Cancellation Policy",
    subtitle: "Please review our cancellation policy before booking. We want you to feel confident every step of the way.",
    image: "https://readdy.ai/api/search-image?query=Calm%20serene%20sky%20with%20soft%20clouds%20during%20sunset%2C%20peaceful%20and%20reassuring%20atmosphere%2C%20deep%20navy%20blue%20and%20warm%20gold%20gradient%20sky%2C%20minimalist%20nature%20photography%2C%20no%20text%2C%20high%20quality&width=1920&height=600&seq=cancelhero01&orientation=landscape",
  },
  policyData: {
    label: "POLICY",
    title: "Cancellation Terms",
    items: [
      { period: "8 or more days before flight", fee: "Free", desc: "No cancellation fee. Date changes are also available." },
      { period: "7 to 2 days before flight", fee: "30% of total price", desc: "A cancellation fee applies. One date change is permitted." },
      { period: "1 day before flight", fee: "50% of total price", desc: "A cancellation fee applies. Same-day changes are not available." },
      { period: "Day of flight / No-show", fee: "100% of total price", desc: "Full cancellation fee applies." },
    ],
  },
  weatherPolicy: {
    label: "WEATHER",
    title: "Cancellations Due to Weather",
    items: [
      "Safety is our top priority. Flights may be cancelled due to poor visibility, strong winds, or thunderstorms at the operator's discretion.",
      "Weather decisions are typically made on the morning of the flight date.",
      "In the event of a weather cancellation, you may choose to reschedule or receive a full refund.",
      "No cancellation fee applies for weather-related cancellations.",
      "If conditions look unstable, our staff may contact you in advance.",
    ],
  },
  otherNotes: {
    label: "NOTE",
    title: "Additional Notes",
    items: [
      "Changes to your reservation (date or number of guests) must be requested at least 7 days before the flight.",
      "Price reductions due to a decrease in the number of guests are generally not available.",
      "Gift tickets are valid for 6 months from the date of purchase.",
      "Gift ticket refunds are available within 7 days of purchase only.",
      "Cancellations due to special circumstances (illness, natural disasters, etc.) will be considered on a case-by-case basis.",
    ],
  },
};
